class FilterContainer extends HTMLElement {
  constructor() {
    super();
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  connectedCallback() {
    // expand filter container
    this.expandButton = this.querySelector('#filter-expand-button');
    this.handleFilterExpand = this.handleFilterExpand.bind(this);
    this.expandButton.addEventListener('click', this.handleFilterExpand);

    // update URL for filtering
    this.filterInputs = this.querySelectorAll('input');
    this.handleFilterToggle = this.handleFilterToggle.bind(this);
    this.filterInputs.forEach((input) => {
      input.addEventListener('change', this.handleFilterToggle);
    })
  }

  disconnectedCallback() {
    this.expandButton.removeEventListener('click', this.handleFilterExpand);
  }

  handleFilterExpand() {
    if (this.dataset.filterContainer === 'close') {
      this.dataset.filterContainer = 'open';
    } else if (this.dataset.filterContainer === 'open') {
      this.dataset.filterContainer = 'close';
    }
  }

  handleFilterToggle(event) {
    const input = event.currentTarget;
    const url = new URL(input.checked ? input.dataset.urlToAdd : input.dataset.urlToRemove, window.location.origin);

    url.searchParams.set("section_id", this.sectionId);

    fetch(url.toString())
      .then(response => {
        return response.text();
      })
      .then(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        document.querySelector('#collection-main').innerHTML = tempDiv.querySelector('#collection-main').innerHTML;

        url.searchParams.delete('section_id');
        window.history.pushState({}, "", url.toString());
      })
  }
}

customElements.define('filter-container', FilterContainer);
